
(() => {
  if (customElements.get('rbnl-autumn-builder-v1')) return;
  class QunatureBundleBuilder extends HTMLElement {
constructor() {
  super();
  this.bundleItems = new Map();
  this.productPreviewCache = new Map();
  this.summaryNodeCache = new Map();
  this.toastTimer = null;
  this.drawerTrigger = null;
  this.boundClick = this.handleClick.bind(this);
  this.boundChange = this.handleChange.bind(this);
  this.boundKeydown = this.handleKeydown.bind(this);
  this.boundStickyOffset = () => {
    if (this.drawer?.classList.contains('is-open')) return;
    if (this.stickyFrame) return;
    this.stickyFrame = requestAnimationFrame(() => {
      const header = document.querySelector('[id$="__header"]');
      const top=Math.max(0,header?.getBoundingClientRect().bottom||0);
      this.style.setProperty('--qn-sticky-top',top+'px');
      this.syncMobileBar();
      const sentinel=this.querySelector('[data-qn-nav-sentinel]');
      const nav=this.querySelector('.qn-bundle__sticky-navigation');
      if (nav) {
        nav.dataset.navCompact=String(this.isMobileView() && this.dataset.mobileNavigation==='compact');
        const quickNav=this.querySelector('[data-qn-quick-nav]');
        if (quickNav) {
          const shown=true;
          quickNav.classList.toggle('is-visible',shown);
          quickNav.inert=!shown;
          quickNav.setAttribute('aria-hidden',String(!shown));
        }
      }
      this.stickyFrame = null;
    });
  };
  this.boundPromotionCheck = () => {
    if (this.promotionExpired !== this.isPromotionExpired()) this.updateSummary();
  };
}
prepareCardOptions(scope = this) {
  scope.querySelectorAll('[data-qn-product-card]:not([data-qn-product-preview-clone]):not([data-qn-options-ready])').forEach(card => {
    card.setAttribute('data-qn-options-ready', '');
    const group = card.querySelector('.qn-bundle-card__variants');
    if (!group) return;
    let names = [];
    try { names = JSON.parse(card.dataset.qnOptionNames || '[]'); } catch (_) { /* Leave the card usable. */ }
    const colorIndex = names.findIndex(name => /^(colou?r|kleur|farbe|颜色|patroon|pattern|dessin)$/i.test(String(name)));
    const hasSize = names.some(name => /^(size|maat|größe|groesse|尺寸|尺码)(\b|\s|$)/i.test(String(name)));
    const swatches = [...group.querySelectorAll('[data-qn-variant-label]')];
    card.dataset.qnNeedsChoice = String(hasSize || (names.length > 0 && colorIndex < 0 && swatches.length > 1));
    if (colorIndex < 0 || swatches.length <= 1) { group.hidden = true; return; }
    const seen = new Set();
    swatches.forEach(label => {
      const input = label.querySelector('[data-qn-variant-input]');
      const color = String(input?.dataset.variantTitle || '').split(' / ')[colorIndex]?.trim();
      if (!color || seen.has(color.toLocaleLowerCase())) { label.remove(); return; }
      seen.add(color.toLocaleLowerCase());
      label.title = color;
      input.setAttribute('aria-label', color);
      const text = label.querySelector('.qn-bundle-swatch__text');
      if (text) text.textContent = color.slice(0, 2).toUpperCase();
      label.querySelector('img')?.setAttribute('alt', color);
    });
    group.querySelector('.qn-bundle-card__variants-label').textContent = 'Kleur';
    const more = group.querySelector('[data-qn-more-variants]');
    if (more) { more.textContent = 'Alle kleuren ↗'; more.setAttribute('aria-label', 'Alle kleuren en maten bekijken'); }
  });
}
connectedCallback() {
  this.summaryNodeCache.clear();
  this.minItems = this.readNumber('minItems', 1);
  this.threshold1 = this.readNumber('threshold1', 6900, true);
  this.threshold2 = this.readNumber('threshold2', Infinity, true);
  if (this.threshold2 <= this.threshold1) this.threshold2 = Infinity;
  this.refreshRewardConfig();
  this.rewardChoice = '';
  this.giftSize = '';
  this.giftColor = '';
  this.buildGiftSelectors();
  this.baseCheckoutLabel = '';
  this.currency = this.dataset.currency || 'EUR';
  this.locale = this.dataset.locale || document.documentElement.lang || 'de';
  this.rootUrl = this.normalizeRoot(this.dataset.rootUrl || '/');
  this.labels = {
    add: this.dataset.labelAdd || 'Toevoegen',
    added: this.dataset.labelAdded || 'Toegevoegd',
    inStock: this.dataset.labelInStock || 'Op voorraad',
    outStock: this.dataset.labelOutStock || 'Niet beschikbaar',
    outStockToast: this.dataset.labelOutStockToast || 'Deze variant is momenteel niet beschikbaar.',
    items: this.dataset.labelItems || 'Artikel',
    singular: this.dataset.labelItemSingular || 'artikelen gekozen',
    plural: this.dataset.labelItemPlural || 'artikelen gekozen',
    progressFirst: this.dataset.labelProgressFirst || 'Nog [amount] voor je gratis fietsbel',
    progressSecond: this.dataset.labelProgressSecond || 'Sturmhaube geschenkt · Noch [amount] bis zum Gratis-Kissen',
    progressUnlocked: this.dataset.labelProgressUnlocked || 'Een gratis fietsbel voor jou!',
    chooseReward: this.dataset.labelChooseReward || 'Cadeau kiezen',
    rewardNeeded: this.dataset.labelRewardNeeded || 'Kies de kleur van je gratis fietsbel.',
    rewardConfig: this.dataset.labelRewardConfig || 'Dit cadeau is nog niet volledig ingesteld.',
    cartError: this.dataset.labelCartError || 'Toevoegen aan de winkelwagen is niet gelukt.'
  };
  this.categoryTabs = [...this.querySelectorAll('[data-qn-category-tab]')];
  this.categoryPanels = new Map(
    [...this.querySelectorAll('[data-qn-category-panel]')].map((panel) => [panel.dataset.qnCategoryPanel, panel])
  );
  this.categoryScroller = this.querySelector('[data-qn-category-scroller]');
  this.activeCategoryId = this.querySelector('[data-qn-category-tab][aria-selected="true"]')?.dataset.qnCategoryTarget
    || this.querySelector('[data-qn-category-panel]:not([hidden])')?.dataset.qnCategoryPanel
    || '';
  this.checkoutButtons = [...this.querySelectorAll('[data-qn-checkout]')];
  this.baseCheckoutLabel = this.checkoutButtons[0]?.textContent?.trim() || 'In de winkelwagen';
  this.mobileBar = this.querySelector('[data-qn-mobile-bar]');
  this.drawer = this.querySelector('[data-qn-drawer]');
  this.overlay = this.querySelector('[data-qn-overlay]');
  this.productPreviewDrawer = this.querySelector('[data-qn-product-preview-drawer]');
  this.productPreviewOverlay = this.querySelector('[data-qn-product-preview-overlay]');
  this.productPreviewContent = this.querySelector('[data-qn-product-preview-content]');
  this.productPreviewTrigger = null;
  this.toast = this.querySelector('[data-qn-toast]');
  this.addEventListener('click', this.boundClick);
  this.addEventListener('change', this.boundChange);
  document.addEventListener('keydown', this.boundKeydown);
  this.rewardConfigObserver = new MutationObserver((mutations) => {
    const changed = mutations.some((mutation) =>
      mutation.type === 'attributes' &&
      mutation.attributeName &&
      (           mutation.attributeName.startsWith('data-gift-') ||
       mutation.attributeName.startsWith('data-threshold-') ||
       mutation.attributeName === 'data-promotion-ends-at')
    );
    if (!changed) return;
    this.refreshRewardConfig();
    this.updateSummary();
  });
  this.rewardConfigObserver.observe(this, { attributes: true });
  this.querySelectorAll('[data-qn-delivery]').forEach(el=>{el.textContent=this.deliveryLabel();});
  this.prepareCardOptions();
  this.syncProductPages();
  this.updateSummary();
  this.applyProductOrder();
  this.promotionTimer = window.setInterval(this.boundPromotionCheck, 1000);
  document.addEventListener('visibilitychange', this.boundPromotionCheck);
  window.addEventListener('scroll', this.boundStickyOffset, {passive: true});
  window.addEventListener('resize', this.boundStickyOffset);
  this.boundStickyOffset();
}
disconnectedCallback() {
  this.rankingController?.abort();
  this.previewDockCleanup?.();
  this.removeEventListener('click', this.boundClick);
  this.removeEventListener('change', this.boundChange);
  document.removeEventListener('keydown', this.boundKeydown);
  if (this.rewardConfigObserver) this.rewardConfigObserver.disconnect();
  if (this.toastTimer) window.clearTimeout(this.toastTimer);
  if (this.promotionTimer) window.clearInterval(this.promotionTimer);
  if (this.runnerTimer) window.clearTimeout(this.runnerTimer);
  if (this.runnerFrame) cancelAnimationFrame(this.runnerFrame);
  if (this.celebrationTimer) window.clearTimeout(this.celebrationTimer);
  document.removeEventListener('visibilitychange', this.boundPromotionCheck);
  window.removeEventListener('scroll', this.boundStickyOffset);
  window.removeEventListener('resize', this.boundStickyOffset);
  if (this.stickyFrame) cancelAnimationFrame(this.stickyFrame);
}
deliveryLabel() {
  return this.dataset.deliveryText || '';
}
isGermanHoliday(date) {
  const y=date.getUTCFullYear(), m=date.getUTCMonth()+1, d=date.getUTCDate();
  if(['1-1','5-1','10-3','12-25','12-26'].includes(m+'-'+d)) return true;
  const a=y%19,b=Math.floor(y/100),c=y%100,e=b%4,f=Math.floor((b+8)/25),g=Math.floor((b-f+1)/3),h=(19*a+b-Math.floor(b/4)-g+15)%30,i=Math.floor(c/4),k=c%4,l=(32+2*e+2*i-h-k)%7,n=Math.floor((a+11*h+22*l)/451),month=Math.floor((h+l-7*n+114)/31),day=(h+l-7*n+114)%31+1;
  const easter=Date.UTC(y,month-1,day,12);
  return [-2,1,39,50].some(offset=>date.getTime()===easter+offset*86400000);
}
isPromotionExpired(now = Date.now()) {
  const configuredEnd = (this.dataset.promotionEndsAt || '').trim();
  if (!configuredEnd) return false;
  const endsAt = Date.parse(configuredEnd);
  return !Number.isFinite(endsAt) || now >= endsAt;
}
refreshRewardConfig() {
  this.threshold1 = this.readNumber('threshold1', this.threshold1 || 6900, true);
  this.threshold2 = this.readNumber('threshold2', Infinity, true);
  if (this.threshold2 <= this.threshold1) this.threshold2 = Infinity;
  this.giftCode1 = (this.getAttribute('data-gift-code-1') || '').trim();
  this.giftCode2 = (this.getAttribute('data-gift-code-2') || '').trim();
  if (!this.giftOptions) {
    try { this.giftOptions = JSON.parse(this.querySelector('[data-qn-gift-options]')?.textContent || '{}'); }
    catch { this.giftOptions = {}; }
    this.giftOptions.masks ||= []; this.giftOptions.singleSets ||= []; this.giftOptions.sets ||= []; this.giftOptions.pillows ||= [];
  }
  this.gift1 = {
    shortName: this.getAttribute('data-gift-short-name-1') || '',
    url: this.getAttribute('data-gift-url-1') || '',
    variantId: String(this.getAttribute('data-gift-variant-1') || ''),
    title: this.getAttribute('data-gift-title-1') || '',
    image: this.getAttribute('data-gift-image-1') || '',
    value: this.readNumber('giftValue1', 0, true),
    available: this.getAttribute('data-gift-available-1') === 'true'
  };
  this.gift2 = {
    shortName: this.getAttribute('data-gift-short-name-2') || '',
    url: this.getAttribute('data-gift-url-2') || '',
    variantId: String(this.getAttribute('data-gift-variant-2') || ''),
    title: this.getAttribute('data-gift-title-2') || '',
    image: this.getAttribute('data-gift-image-2') || '',
    value: this.readNumber('giftValue2', 0, true),
    available: this.getAttribute('data-gift-available-2') === 'true'
  };
  this.gift1 = this.selectedGift(1, this.gift1);
  this.gift2 = this.selectedGift(2, this.gift2);
}
selectedGift(level, base) {
  if (level === 2) {
    const mask = this.giftOptions.masks.find(v => String(v.id) === base.variantId);
    return {...base, available:Boolean(mask?.available), value:mask?.price || base.value || 0,
      image:mask?.image || base.image, title:'Zwarte bivakmuts', shortName:'Zwarte bivakmuts · 1 stuk'};
  }
  const chosen = this.giftOptions.singleSets.find(v => v.size === this.giftSize);
  return { ...base, variantId: chosen ? String(chosen.id) : '', available: Boolean(chosen?.available),
    value: chosen?.price || 0, image: chosen?.image || this.giftOptions.singleSets[0]?.image || base.image,
    title: 'ROCKBROS-fietsbel', shortName: `Fietsbel · ${this.giftColorLabel(this.giftSize) || 'Kies je kleur'}` };
}
giftColorLabel(value) { return ({Black:'Zwart',Red:'Rood',Titanium:'Titanium'})[value] || value; }
buildGiftSelectors() {
  const esc = value => this.escapeHtml(value);
  const html = `<div class="qn-gift-choice-group"><div class="qn-gift-choice-preview"><strong>Gratis fietsbel · Kleur</strong><button type="button" class="qn-gift-preview-link" data-qn-preview-gift="1">Details ↗</button></div><div class="qn-gift-choice-options qn-gift-choice-options--colors" role="group" aria-label="Kleur van de fietsbel">${this.giftOptions.singleSets.map(v => `<button type="button" data-qn-gift-size="${esc(v.size)}" aria-pressed="false" ${v.available ? '' : 'disabled'}><img src="${esc(v.image)}" width="42" height="42" alt="" loading="lazy"><span>${esc(this.giftColorLabel(v.size))}</span></button>`).join('')}</div></div>`;
  this.querySelectorAll('[data-qn-gift-selection]').forEach(el => { el.innerHTML = html + `<div class="qn-gift-choice-group" data-qn-mask-group hidden><div class="qn-gift-choice-preview"><strong>Zwarte bivakmuts · 1 stuk</strong><button type="button" class="qn-gift-preview-link" data-qn-preview-gift="2">Details ↗</button></div><p>Bij €99 krijg je ook deze bivakmuts cadeau.</p></div>`; });
  this.summaryNodeCache.clear();
}
chooseGiftOption(button) {
  if (button.disabled) return;
  if (button.hasAttribute('data-qn-gift-size')) this.giftSize = button.dataset.qnGiftSize;
  if (button.hasAttribute('data-qn-gift-color')) this.giftColor = button.dataset.qnGiftColor;
  this.updateSummary();
  const card = button.closest('[data-qn-product-preview-clone]');
  if (card?.dataset.qnGiftPreviewLevel) {
    const details = card.querySelector('[data-qn-product-preview-details]');
    this.loadProductPreviewDetails(card.querySelector('.qn-product-preview__details-link').href, details);
  }
}
normalizeRoot(root) {
  let result = String(root || '/');
  if (!result.startsWith('/')) result = '/' + result;
  if (!result.endsWith('/')) result += '/';
  return result;
}
readNumber(key, fallback, allowZero = false) {
  const attrName = `data-${String(key)
    .replace(/([A-Z])/g, '-$1')
    .toLowerCase()
    .replace(/(\d+)$/, '-$1')}`;
  const raw = this.getAttribute(attrName);
  const value = Number(raw);
  if (!Number.isFinite(value)) return fallback;
  if (!allowZero && value <= 0) return fallback;
  return value;
}
escapeHtml(value) {
  return String(value ?? '').replace(/[&<>'"]/g, (char) => ({
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    "'": '&#039;',
    '"': '&quot;'
  })[char]);
}
formatMoney(cents) {
  const amount = (Number(cents) || 0) / 100;
  try {
    const key = `${this.locale}:${this.currency}`;
    if (this.moneyFormatterKey !== key) {
      this.moneyFormatter = new Intl.NumberFormat(this.locale, {
        style: 'currency',
        currency: this.currency,
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      });
      this.moneyFormatterKey = key;
    }
    return this.moneyFormatter.format(amount);
  } catch (error) {
    return `${this.currency} ${amount.toFixed(2)}`;
  }
}
getPanelProductRoot(panel) {
  return panel?.querySelector('template[data-qn-panel-products]')?.content
    || panel?.querySelector('.qn-bundle__products') || panel;
}
mountCategoryProducts(panel) {
  const template = panel?.querySelector('template[data-qn-panel-products]');
  if (!template) return;
  template.replaceWith(template.content);
  this.prepareCardOptions(panel);
  panel.querySelectorAll('[data-qn-add]').forEach(button => this.syncAddButtonState(button));
}
async applyProductOrder() {
  this.rankingController?.abort();
  const controller = new AbortController();
  this.rankingController = controller;
  const panels = [...this.categoryPanels.values()];
  panels.forEach(panel => {
    this.getPanelProductRoot(panel).querySelectorAll('[data-qn-product-card]').forEach((card, index) => {
      if (!card.hasAttribute('data-original-order')) card.dataset.originalOrder = String(index);
    });
  });
  const restore = () => {
    panels.forEach(panel => {
      const grid = this.getPanelProductRoot(panel);
      [...grid.querySelectorAll('[data-qn-product-card]')]
        .sort((a, b) => Number(a.dataset.originalOrder) - Number(b.dataset.originalOrder))
        .forEach(card => grid.append(card));
    });
    this.syncProductPages();
  };
  if (this.dataset.productOrder !== 'best-selling') {
    restore();
    this.dataset.productOrderStatus = 'original';
    return;
  }
  this.dataset.productOrderStatus = 'loading';
  try {
    if (!this.dataset.rankingCollectionUrl) throw new Error('Missing ranking collection');
    let url = new URL(this.dataset.rankingCollectionUrl, location.origin);
    url.searchParams.set('sort_by', 'best-selling');
    url.searchParams.set('section_id', 'rbnl-autumn-rank');
    const rank = new Map();
    const needed = new Set(panels.flatMap(panel => [...this.getPanelProductRoot(panel).querySelectorAll('[data-qn-product-card]')].map(card => card.dataset.productId)));
    for (let page = 0; page < 100; page++) {
      const response = await fetch(url, {signal: controller.signal, credentials: 'same-origin'});
      if (!response.ok) throw new Error('Ranking unavailable');
      const html = new DOMParser().parseFromString(await response.text(), 'text/html');
      const data = JSON.parse(html.querySelector('[data-rbnl-product-rank]')?.textContent || 'null');
      if (!Array.isArray(data?.ids) || data.sort !== 'best-selling') throw new Error('Invalid ranking');
      data.ids.forEach(id => {
        const key = String(id);
        if (!rank.has(key)) rank.set(key, rank.size);
        needed.delete(key);
      });
      if (!data.next || needed.size === 0) break;
      url = new URL(data.next, location.origin);
      if (url.origin !== location.origin) throw new Error('Invalid ranking URL');
      url.searchParams.set('sort_by', 'best-selling');
      url.searchParams.set('section_id', 'rbnl-autumn-rank');
    }
    if (controller.signal.aborted || !this.isConnected) return;
    panels.forEach(panel => {
      const grid = this.getPanelProductRoot(panel);
      [...grid.querySelectorAll('[data-qn-product-card]')]
        .sort((a, b) => (rank.get(a.dataset.productId) ?? Number.MAX_SAFE_INTEGER) - (rank.get(b.dataset.productId) ?? Number.MAX_SAFE_INTEGER) || Number(a.dataset.originalOrder) - Number(b.dataset.originalOrder))
        .forEach(card => grid.append(card));
    });
    this.syncProductPages();
    this.dataset.productOrderStatus = 'best-selling';
  } catch (error) {
    if (controller.signal.aborted) return;
    restore();
    this.dataset.productOrderStatus = 'fallback';
  }
}
syncProductPages() {
  this.categoryPanels.forEach(panel => {
    const cards = [...this.getPanelProductRoot(panel).querySelectorAll('[data-qn-product-card]')];
    const visible = Number(panel.dataset.visibleProducts || 8);
    cards.forEach((card, index) => card.classList.toggle('qn-mobile-product-deferred', index >= visible));
    let button = panel.querySelector('[data-qn-more-products]');
    if (!button && cards.length > 8) {
      button = document.createElement('button');
      button.type = 'button';
      button.className = 'qn-more-products';
      button.setAttribute('data-qn-more-products', '');
      panel.append(button);
    }
    if (button) {
      button.hidden = visible >= cards.length;
      button.textContent = `Meer producten bekijken (${Math.max(0, cards.length - visible)})`;
    }
  });
}
handleClick(event) {
  const zoom = event.target.closest('[data-qn-preview-zoom], [data-qn-product-preview-clone] [data-qn-main-image]');
  if (zoom && this.contains(zoom)) {
    const image = zoom.closest('[data-qn-product-preview-clone]').querySelector('[data-qn-main-image]');
    if (!this.imageZoom) {
      const dialog = document.createElement('dialog');
      dialog.className = 'qn-image-zoom';
      dialog.setAttribute('aria-label','Vergrote productafbeelding');
      dialog.innerHTML = '<header><button type="button" data-zoom-toggle aria-pressed="false">Vergroten +</button><button type="button" data-zoom-close aria-label="Afbeelding sluiten">Sluiten ×</button></header><div><img alt=""></div>';
      dialog.addEventListener('keydown',event=>event.stopPropagation());
      dialog.addEventListener('click',event=>{
        event.stopPropagation();
        if (event.target.closest('[data-zoom-close]')) dialog.close();
        if (event.target.closest('[data-zoom-toggle]')) {
          const enlarged = dialog.classList.toggle('is-enlarged');
          const button = dialog.querySelector('[data-zoom-toggle]');
          button.textContent = enlarged ? 'Verkleinen −' : 'Vergroten +';
          button.setAttribute('aria-pressed',String(enlarged));
        }
      });
      this.append(dialog); this.imageZoom = dialog;
    }
    const dialog = this.imageZoom, large = dialog.querySelector('img');
    dialog.classList.remove('is-enlarged');
    dialog.querySelector('[data-zoom-toggle]').textContent='Vergroten +';
    dialog.querySelector('[data-zoom-toggle]').setAttribute('aria-pressed','false');
    large.src = this.previewImageUrl(image.src,1600); large.alt = image.alt;
    dialog.showModal(); dialog.querySelector('div').scrollTo(0,0);
    return;
  }

  const moreProducts = event.target.closest('[data-qn-more-products]');
  if (moreProducts && this.contains(moreProducts)) {
    const panel = moreProducts.closest('[data-qn-category-panel]');
    const previous = Number(panel.dataset.visibleProducts || 8);
    panel.dataset.visibleProducts = String(previous + 8);
    this.syncProductPages();
    // Keep the reader at the first newly revealed product, including keyboard users.
    const firstNew = panel.querySelectorAll('[data-qn-product-card]')[previous];
    firstNew?.querySelector('a')?.focus({preventScroll:true});
    firstNew?.scrollIntoView({block:'nearest', behavior:'auto'});
    return;
  }
  const moreVariants = event.target.closest('[data-qn-more-variants]');
  if (moreVariants && this.contains(moreVariants)) { this.openProductPreview(moreVariants.closest('[data-qn-product-card]'), moreVariants); return; }
  const giftPreview = event.target.closest('[data-qn-preview-gift]');
  if (giftPreview && this.contains(giftPreview)) {
    const giftLevel = giftPreview.dataset.qnPreviewGift;
    const baseGift = giftLevel === '2' ? this.gift2 : this.gift1;
    const mask = this.giftOptions.masks.find(v => String(v.id) === this.gift2.variantId);
    const values = (giftLevel === '2' ? [mask] : this.giftOptions.singleSets).filter(Boolean).map(v => Number(v.price)).filter(v => v > 0);
    const gift = { ...baseGift, value:values.length ? Math.min(...values) : null };
    if (!gift?.url) return;
    const card = document.createElement('article');
    card.className = 'qn-bundle-card';
    card.setAttribute('data-qn-product-card','');
    card.dataset.qnGiftPreviewLevel = giftLevel;
    card.innerHTML = '<div class="qn-bundle-card__media"><a class="qn-bundle-card__media-link" href="'+this.escapeHtml(gift.url)+'"><img class="qn-bundle-card__image" data-qn-main-image src="'+this.escapeHtml(gift.image)+'" alt="'+this.escapeHtml(gift.title)+'"></a></div><h3 class="qn-bundle-card__title">'+this.escapeHtml(gift.title)+'</h3><p data-qn-gift-preview-value>Cadeau · Waarde '+(gift.value ? this.formatMoney(gift.value)+(Math.max(...values)>gift.value ? '–'+this.formatMoney(Math.max(...values)) : '') : 'zie productdetails')+'</p>';
    this.openProductPreview(card, giftPreview);
    return;
  }
  const galleryStep=event.target.closest('[data-qn-gallery-step]');
  if(galleryStep && this.contains(galleryStep)){
    const buttons=[...this.productPreviewContent.querySelectorAll('[data-qn-preview-image]')];
    const current=Math.max(0,buttons.findIndex(button=>button.getAttribute('aria-pressed')==='true'));
    const next=(current+Number(galleryStep.dataset.qnGalleryStep)+buttons.length)%buttons.length;
    buttons[next]?.click(); return;
  }
  const galleryButton = event.target.closest('[data-qn-preview-image]');
  if (galleryButton && this.contains(galleryButton)) {
    const mainImage = this.productPreviewContent.querySelector('[data-qn-main-image]');
    if (mainImage) this.showPreviewImage(mainImage, galleryButton.dataset.qnPreviewImage);
    const buttons=[...galleryButton.parentElement.querySelectorAll('button')];
    buttons.forEach(button => button.setAttribute('aria-pressed', String(button === galleryButton)));
    this.productPreviewContent.querySelector('[data-qn-image-count]').textContent=(buttons.indexOf(galleryButton)+1)+' / '+buttons.length;
    galleryButton.scrollIntoView({block:'nearest',inline:'nearest',behavior:'auto'});
    this.preloadPreviewNeighbors(galleryButton);
    return;
  }
  const retryDetails = event.target.closest('[data-qn-retry-details]');
  if (retryDetails && this.contains(retryDetails)) {
    this.loadProductPreviewDetails(retryDetails.dataset.productUrl, retryDetails.closest('[data-qn-product-preview-details]'));
    return;
  }
  const productLink = event.target.closest('.qn-bundle-card__media-link, .qn-bundle-card__title a');
  if (
    productLink &&
    this.contains(productLink) &&
    !productLink.closest('[data-qn-product-preview-drawer]') &&
    !event.ctrlKey && !event.metaKey && !event.shiftKey && !event.altKey
  ) {
    const card = productLink.closest('[data-qn-product-card]');
    if (card) {
      event.preventDefault();
      this.openProductPreview(card, productLink);
      return;
    }
  }
  const quickCategory = event.target.closest('[data-qn-quick-category]');
  if (quickCategory && this.contains(quickCategory)) {
    this.activateCategory(quickCategory.dataset.qnQuickCategory);
    this.querySelector('.qn-bundle__layout')?.scrollIntoView({block:'start',behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});
    return;
  }
  const categoryTab = event.target.closest('[data-qn-category-tab]');
  if (categoryTab && this.contains(categoryTab)) {
    this.activateCategory(categoryTab.dataset.qnCategoryTarget, categoryTab);
    return;
  }
  const unavailableSwatch = event.target.closest('[data-qn-variant-label][data-available="false"]');
  if (unavailableSwatch && this.contains(unavailableSwatch)) {
    event.preventDefault();
    this.showToast(this.labels.outStockToast, 'error');
    return;
  }
  const addButton = event.target.closest('[data-qn-add]');
  if (addButton && this.contains(addButton)) {
    const card = addButton.closest('[data-qn-product-card]');
    if (card?.dataset.qnNeedsChoice === 'true' && !card.hasAttribute('data-qn-product-preview-clone')) {
      this.openProductPreview(card, addButton);
      return;
    }
    this.toggleBundleItem(addButton);
    return;
  }
  const qtyButton = event.target.closest('[data-qn-qty-action]');
  if (qtyButton && this.contains(qtyButton)) {
    this.changeQuantity(qtyButton.dataset.variantId, qtyButton.dataset.qnQtyAction);
    return;
  }
  const removeButton = event.target.closest('[data-qn-remove]');
  if (removeButton && this.contains(removeButton)) {
    this.removeBundleItem(removeButton.dataset.variantId);
    return;
  }
  const giftOption = event.target.closest('[data-qn-gift-size], [data-qn-gift-color]');
  if (giftOption && this.contains(giftOption)) { this.chooseGiftOption(giftOption); return; }

  const checkout = event.target.closest('[data-qn-checkout]');
  if (checkout && this.contains(checkout)) {
    if (checkout.disabled) return;
    const tier = this.getRewardTier(this.getEligibleSelectionAmount());
    if (!this.cartNeedsReview && tier && !this.isRewardChoiceValid(tier)) {
      this.focusRewardChoice(checkout);
      return;
    }
    this.addBundleToCart(checkout);
    return;
  }
  const openDrawer = event.target.closest('[data-qn-open-drawer]');
  if (openDrawer && this.contains(openDrawer)) {
    this.openDrawer(openDrawer);
    return;
  }
  const closeDrawer = event.target.closest('[data-qn-close-drawer]');
  if (closeDrawer && this.contains(closeDrawer)) {
    this.closeDrawer();
    return;
  }
  const closeProductPreview = event.target.closest('[data-qn-close-product-preview]');
  if (closeProductPreview && this.contains(closeProductPreview)) {
    this.closeProductPreview();
    return;
  }
  if (event.target === this.overlay) {
    this.closeDrawer();
    return;
  }
  if (event.target === this.productPreviewOverlay) {
    this.closeProductPreview();
  }
}
focusRewardChoice(trigger) {
  if (this.isMobileView()) this.openDrawer(trigger);
  const scope = this.isMobileView() ? this.drawer : trigger.closest('.qn-bundle-summary') || this;
  const reward = scope?.querySelector('[data-qn-reward]:not([hidden])');
  if (!reward) return;
  if (reward.tagName === 'DETAILS') reward.open = true;
  requestAnimationFrame(() => {
    const scroller = reward.closest('.qn-bundle-summary__desktop-scroll,.qn-bundle-drawer__content');
    const behavior = matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
    if (scroller) scroller.scrollTo({top:scroller.scrollTop + reward.getBoundingClientRect().top - scroller.getBoundingClientRect().top - 12,behavior});
    else reward.scrollIntoView({block:'nearest',behavior});
    reward.querySelector('[data-qn-gift-size]:not(:disabled)')?.focus({preventScroll:true});
  });
}
activateCategory(targetId, sourceTab = null) {
  const id = String(targetId || '');
  if (!id || !this.categoryPanels.has(id)) return;
  this.mountCategoryProducts(this.categoryPanels.get(id));
  this.categoryTabs.forEach((tab) => {
    const active = tab.dataset.qnCategoryTarget === id;
    tab.setAttribute('aria-selected', active ? 'true' : 'false');
    tab.tabIndex = active ? 0 : -1;
  });
  this.categoryPanels.forEach((panel, panelId) => {
    panel.hidden = panelId !== id;
  });
  this.querySelectorAll('[data-qn-quick-category]').forEach(button=>button.setAttribute('aria-pressed',String(button.dataset.qnQuickCategory===id)));
  this.activeCategoryId = id;
  this.dispatchEvent(new CustomEvent('rbnl:category-change', {detail: {id}}));
  this.syncProductPages();
  if (sourceTab && this.categoryScroller) {
    const tabRect = sourceTab.getBoundingClientRect();
    const scrollerRect = this.categoryScroller.getBoundingClientRect();
    if (tabRect.left < scrollerRect.left + 8 || tabRect.right > scrollerRect.right - 8) {
      const delta = ((tabRect.left + tabRect.right) / 2) - ((scrollerRect.left + scrollerRect.right) / 2);
      this.categoryScroller.scrollTo({
        left: Math.max(0, this.categoryScroller.scrollLeft + delta),
        behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
      });
    }
  }
}
handleChange(event) {
  const previewSelect = event.target.closest('[data-qn-preview-variant]');
  if (previewSelect && this.contains(previewSelect)) {
    this.applyVariantToCard(previewSelect.selectedOptions[0]);
    return;
  }
  const input = event.target.closest('[data-qn-variant-input]');
  if (!input || !this.contains(input)) return;
  if (input.dataset.variantAvailable !== 'true') {
    this.showToast(this.labels.outStockToast, 'error');
    return;
  }
  this.applyVariantToCard(input);
}
handleKeydown(event) {
  const tab = event.target.closest('[data-qn-category-tab]');
  if (tab && this.contains(tab) && ['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) {
    event.preventDefault();
    const index = this.categoryTabs.indexOf(tab);
    const count = this.categoryTabs.length;
    const next = event.key === 'Home' ? 0 : event.key === 'End' ? count - 1 :
      (index + (event.key === 'ArrowRight' ? 1 : -1) + count) % count;
    const target = this.categoryTabs[next];
    this.activateCategory(target.dataset.qnCategoryTarget, target);
    target.focus();
    return;
  }
  const previewOpen = this.productPreviewDrawer?.classList.contains('is-open');
  const activeDialog = previewOpen ? this.productPreviewDrawer :
    (this.drawer?.classList.contains('is-open') ? this.drawer : null);
  if (!activeDialog) return;
  if (event.key === 'Escape') {
    event.preventDefault();
    previewOpen ? this.closeProductPreview() : this.closeDrawer();
  } else if (event.key === 'Tab') {
    const controls = [...activeDialog.querySelectorAll('a[href], button, input, select, textarea, [tabindex]'), ...(previewOpen && this.previewDock ? this.previewDock.querySelectorAll('button') : [])]
      .filter((element) => !element.disabled && element.tabIndex >= 0 && element.getClientRects().length && !element.closest('[hidden], [inert]'));
    const first = controls[0];
    const last = controls[controls.length - 1];
    if (!first) { event.preventDefault(); return; }
    if (!activeDialog.contains(document.activeElement) ||
        (event.shiftKey && document.activeElement === first) ||
        (!event.shiftKey && document.activeElement === last)) {
      event.preventDefault();
      (event.shiftKey ? last : first).focus();
    }
  }
}
applyVariantToCard(input, targetCard = null) {
const card = targetCard || input.closest('[data-qn-product-card]');
if (!card) return;
const allowedVariantIds = card.dataset?.qnAllowedVariantIds;
if (allowedVariantIds && !allowedVariantIds.split(',').includes(input.dataset.variantId || '')) return;
const addButton = card.querySelector('[data-qn-add]');
const currentPrice = card.querySelector('[data-qn-price-current]');
const comparePrice = card.querySelector('[data-qn-price-compare]');
const mainImage = card.querySelector('[data-qn-main-image]');
const stock = card.querySelector('[data-qn-stock]');
let badge = card.querySelector('[data-qn-sale-badge]');
let savings = card.querySelector('[data-qn-savings]');
const variantId = input.dataset.variantId || '';
const variantTitle = input.dataset.variantTitle || '';
const selectedLabel=card.querySelector('[data-qn-selected-variant-title]');
if(selectedLabel) selectedLabel.textContent='Jouw variant: '+variantTitle;
const listLabel = card.querySelector('.qn-bundle-card__variants-label');
if (listLabel) {
  listLabel.textContent = variantTitle;
  listLabel.title = variantTitle;
}
const price = Number(input.dataset.variantPrice || 0);
const compare = Number(input.dataset.variantCompare || 0);
const image = input.dataset.variantImage || '';
const available = input.dataset.variantAvailable === 'true';
if (addButton) {
  addButton.dataset.variantId = variantId;
  addButton.dataset.variantTitle = variantTitle;
  addButton.dataset.productPrice = String(price);
  addButton.dataset.productCompare = String(compare);
  addButton.dataset.productImage = image;
  addButton.disabled = !available;
  this.syncAddButtonState(addButton);
}
if (currentPrice) currentPrice.textContent = this.formatMoney(price);
if (comparePrice) {
  const hasCompare = compare > price;
  comparePrice.hidden = !hasCompare;
  comparePrice.textContent = hasCompare ? this.formatMoney(compare) : '';
}
if (mainImage && image) {
  this.previewImageRequest = (this.previewImageRequest || 0) + 1;
  mainImage.closest('.qn-bundle-card__media')?.removeAttribute('aria-busy');
  mainImage.src = image;
  mainImage.removeAttribute('srcset');
}
if (compare > price) {
  if (!savings) {
    savings = document.createElement('p');
    savings.className = 'qn-bundle-card__savings';
    savings.dataset.qnSavings = '';
    card.querySelector('.qn-bundle-card__price').after(savings);
  }
  savings.textContent = 'Je bespaart ' + this.formatMoney(compare - price);
} else savings?.remove();
if (stock) {
  stock.dataset.available = available ? 'true' : 'false';
  stock.textContent = available ? this.labels.inStock : this.labels.outStock;
}
const discount = compare > price && compare > 0 ? Math.floor(((compare - price) / compare) * 100) : 0;
if (discount > 0) {
  if (!badge) {
    badge = document.createElement('span');
    badge.className = 'qn-bundle-card__badge';
    badge.dataset.qnSaleBadge = '';
    card.querySelector('.qn-bundle-card__media').append(badge);
  }
  badge.textContent = `-${discount}%`;
} else badge?.remove();
if (card.hasAttribute('data-qn-product-preview-clone')) {
  this.syncPreviewGallery(card);
  const productId = addButton?.dataset.productId;
  if (productId) this.querySelectorAll('[data-qn-product-card]').forEach(source => {
    if (source.hasAttribute('data-qn-product-preview-clone') || source.querySelector('[data-qn-add]')?.dataset.productId !== productId) return;
    source.querySelectorAll('[data-qn-variant-input]').forEach(radio => {
      radio.checked = radio.dataset.variantId === variantId;
    });
    this.applyVariantToCard(input, source);
  });
}
}
syncPreviewGallery(card) {
  const image = card.querySelector('[data-qn-main-image]');
  const buttons = [...card.querySelectorAll('[data-qn-preview-image]')];
  if (!image || !buttons.length) return;
  const selected = buttons.findIndex(button => this.previewImageUrl(button.dataset.qnPreviewImage) === this.previewImageUrl(image.src));
  buttons.forEach((button, index) => button.setAttribute('aria-pressed', String(index === selected)));
  const count = card.querySelector('[data-qn-image-count]');
  if (count) count.textContent = selected >= 0 ? `${selected + 1} / ${buttons.length}` : 'Variantafbeelding';
}
syncAddButtonState(button) {
  const variantId = String(button.dataset.variantId || '');
  const isAdded = this.bundleItems.has(variantId);
  button.classList.toggle('is-added', isAdded);
  button.textContent = isAdded ? this.labels.added : this.labels.add;
  let controls = button.parentElement?.querySelector('[data-qn-card-quantity]');
  if (!controls && button.parentElement) {
    controls = document.createElement('div');
    controls.className = 'qn-card-quantity';
    controls.setAttribute('data-qn-card-quantity', '');
    controls.innerHTML = '<button type="button" data-qn-qty-action="decrease" aria-label="Aantal verlagen">−</button><output aria-live="polite"></output><button type="button" data-qn-qty-action="increase" aria-label="Aantal verhogen">+</button>';
    button.after(controls);
  }
  if (controls) {
    const focusedAdd = document.activeElement === button;
    const focusedControls = controls.contains(document.activeElement);
    controls.querySelectorAll('button').forEach(control => {
      control.dataset.variantId = variantId;
      control.disabled = control.dataset.qnQtyAction === 'increase' && button.disabled;
    });
    controls.querySelector('output').textContent = String(this.bundleItems.get(variantId)?.quantity || 0);
    controls.hidden = !isAdded;
    button.hidden = isAdded;
    if (isAdded && focusedAdd) controls.querySelector('[data-qn-qty-action="increase"]').focus({preventScroll:true});
    if (!isAdded && focusedControls) button.focus({preventScroll:true});
  }
}
syncAllAddButtons(variantId) {
  const id = String(variantId || '');
  if (!id) return;
  this.querySelectorAll('[data-qn-add]').forEach((button) => {
    if (String(button.dataset.variantId || '') === id) this.syncAddButtonState(button);
  });
}
toggleBundleItem(button) {
  if (button.disabled) return;
  const variantId = String(button.dataset.variantId || '');
  if (!variantId) return;
  if (this.bundleItems.has(variantId)) {
    this.changeQuantity(variantId, 'increase');
    return;
  }
  const item = {
    productId: String(button.dataset.productId || ''),
    promoEligible: button.dataset.promoEligible === 'true',
    variantId,
    title: button.dataset.productTitle || '',
    variant: button.dataset.variantTitle || '',
    price: Number(button.dataset.productPrice || 0),
    compare: Number(button.dataset.productCompare || 0),
    image: button.dataset.productImage || '',
    quantity: 1
  };
  this.bundleItems.set(variantId, item);
  this.syncAllAddButtons(variantId);
  this.updateSummary();
  this.animateShoppingFeedback(button);
}
animateRunner(unlockedLevel = 0, progressValue = 0) {
  if (this.runnerTimer) clearTimeout(this.runnerTimer);
  if (this.runnerFrame) cancelAnimationFrame(this.runnerFrame);
  if (this.celebrationTimer) clearTimeout(this.celebrationTimer);
  this.runnerFrame = null;
  this.rewardReveal?.setAttribute('hidden', '');
  const runners = this.summaryNodes('.qn-bundle-runner');
  runners.forEach(runner => runner.classList.remove('is-moving', 'is-stopping', 'is-celebrating'));
  const stage = progressValue < 34 ? 1 : progressValue < 67 ? 2 : 3;
  runners.forEach(runner => { runner.dataset.motionStage = String(stage); });
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches || document.hidden || this.drawer?.classList.contains('is-open') || document.body.classList.contains('qn-autumn-video-in-view')) return;
  const start = performance.now();
  const legs = runners.map(runner => ({runner, paths:[...runner.querySelectorAll('[data-bike-leg]')], crank:runner.querySelector('.rb-bike-crank')}));
  runners.forEach(runner => runner.classList.add('is-moving'));
  const frame = now => {
    if (document.hidden || this.drawer?.classList.contains('is-open') || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      runners.forEach(runner => runner.classList.remove('is-moving', 'is-stopping'));
      this.runnerFrame = null;
      return;
    }
    const elapsed = now - start;
    const stop = Math.min(1, Math.max(0, (elapsed - 900) / 280));
    const ease = stop * stop * (3 - 2 * stop);
    const phase = Math.min(elapsed, 900) / [0, 800, 650, 520][stage] * Math.PI * 2;
    legs.forEach(({runner, paths, crank}) => {
      if (stop > 0) { runner.classList.remove('is-moving'); runner.classList.add('is-stopping'); }
      paths.forEach((path, index) => {
        const angle = phase + index * Math.PI;
        let x = 33 + Math.cos(angle) * 5, y = 43 + Math.sin(angle) * 5;
        x += ((index ? 29 : 36) - x) * ease;
        y += ((index ? 53 : 43) - y) * ease;
        const hipX = 27, hipY = 26, dx = x - hipX, dy = y - hipY;
        const distance = Math.hypot(dx,dy), bend = Math.sqrt(Math.max(0, 15*15-distance*distance/4));
        const kneeX = hipX + dx/2 + dy/distance*bend, kneeY = hipY + dy/2 - dx/distance*bend;
        path.setAttribute('d', `M${hipX} ${hipY}L${kneeX.toFixed(2)} ${kneeY.toFixed(2)}L${x.toFixed(2)} ${y.toFixed(2)}l4 0`);
      });
      if (crank) crank.setAttribute('transform', `rotate(${phase*180/Math.PI} 33 43)`);
    });
    if (elapsed < 1180) this.runnerFrame = requestAnimationFrame(frame);
    else {
      this.runnerFrame = null;
      runners.forEach(runner => runner.classList.remove('is-moving','is-stopping'));
      if (unlockedLevel) this.celebrateReward(unlockedLevel);
    }
  };
  this.runnerFrame = requestAnimationFrame(frame);
}
celebrateReward(level) {
  if (this.celebrationTimer) clearTimeout(this.celebrationTimer);
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (document.hidden || this.drawer?.classList.contains('is-open') || document.body.classList.contains('qn-autumn-video-in-view')) return;
  const runners = this.summaryNodes('.qn-bundle-runner');
  runners.forEach(runner => {
    runner.dataset.rewardLevel = String(level);
    runner.classList.add('is-celebrating');
  });
  const revealHost = window.matchMedia('(min-width:990px)').matches ? this.querySelector('.qn-bundle__summary-wrap .qn-bundle-summary__progress') : this.mobileBar;
  if (revealHost) {
    if (!this.rewardReveal) {
      this.rewardReveal = document.createElement('div');
      this.rewardReveal.className = 'qn-gift-reveal';
      this.rewardReveal.setAttribute('aria-hidden', 'true');
      revealHost.append(this.rewardReveal);
    }
    if (this.rewardReveal.parentElement !== revealHost) revealHost.append(this.rewardReveal);
    const gifts = [{image:this.gift1?.image, title:'Fietsbel'}];
    if (level === 2) gifts.push({image:this.gift2?.image, title:'Zwarte bivakmuts'});
    this.rewardReveal.innerHTML = `<strong class="qn-gift-reveal__heading">${level === 2 ? 'Je cadeaus staan klaar' : 'Je gratis fietsbel staat klaar'}</strong><div class="qn-gift-reveal__cards">${gifts.map(gift => `<div class="qn-gift-reveal__card">${gift.image ? `<img src="${this.escapeHtml(gift.image)}" alt="">` : ''}<span>${gift.title}<small>GRATIS</small></span></div>`).join('')}</div>`;
    this.rewardReveal.hidden = false;
  }
  this.celebrationTimer = setTimeout(() => {
    runners.forEach(runner => runner.classList.remove('is-celebrating'));
    if (this.rewardReveal) this.rewardReveal.hidden = true;
  }, 2200);
}
animateShoppingFeedback(button) {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  const target = (this.isMobileView() ? this.mobileBar : this.querySelector('[data-qn-summary]'));
  const destination = target?.getBoundingClientRect();
  const image = button.closest('[data-qn-product-card]')?.querySelector('[data-qn-main-image]');
  const origin = image?.getBoundingClientRect();
  if (!destination || !origin || !image) return;
  const flying = image.cloneNode();
  flying.removeAttribute('srcset');
  flying.removeAttribute('data-qn-main-image');
  flying.setAttribute('aria-hidden','true');
  Object.assign(flying.style,{position:'fixed',left:origin.left+'px',top:origin.top+'px',width:'54px',height:'54px',objectFit:'contain',borderRadius:'50%',background:'#fff',pointerEvents:'none',zIndex:'1200'});
  document.body.append(flying);
  flying.animate([{transform:'translate(0,0) scale(1)',opacity:1},{transform:'translate('+(destination.left-origin.left+25)+'px,'+(destination.top-origin.top)+'px) scale(.25)',opacity:0}],{duration:600,easing:'cubic-bezier(.4,0,.2,1)'}).finished.finally(()=>flying.remove());
}
removeBundleItem(variantId) {
  const id = String(variantId || '');
  if (!id) return;
  this.bundleItems.delete(id);
  this.syncAllAddButtons(id);
  this.updateSummary();
}
changeQuantity(variantId, action) {
  const item = this.bundleItems.get(String(variantId || ''));
  if (!item) return;
  if (action === 'increase') {
    item.quantity += 1;
  } else if (action === 'decrease') {
    if (item.quantity <= 1) {
      this.removeBundleItem(variantId);
      return;
    }
    item.quantity -= 1;
  }
  this.syncAllAddButtons(variantId);
  this.updateSummary();
}
getTotalQuantity() {
  let count = 0;
  this.bundleItems.forEach((item) => {
    count += Math.max(0, Number(item.quantity) || 0);
  });
  return count;
}
getEligibleSelectionAmount() {
  let amount = 0;
  this.bundleItems.forEach(item => { if (item.promoEligible === true) amount += item.price * item.quantity; });
  return amount;
}
getRewardTier(subtotal) {
  if (Number(subtotal) >= this.threshold2) return {level:2,threshold:this.threshold2,giftCode:this.giftCode2,gift:this.gift1,gifts:[this.gift1,this.gift2]};
  return Number(subtotal) >= this.threshold1 ? {level:1,threshold:this.threshold1,giftCode:this.giftCode1,gift:this.gift1,gifts:[this.gift1]} : null;
}
getProgress(subtotal) {
  const target = Number.isFinite(this.threshold2) ? this.threshold2 : this.threshold1;
  return Math.max(0, Math.min(100, Number(subtotal) / Math.max(1,target) * 100));
}
getProgressText(subtotal) {
  if (this.isPromotionExpired()) return 'Deze actie is afgelopen.';
  if (Number(subtotal) < this.threshold1) return this.labels.progressFirst.replace('[amount]',this.formatMoney(this.threshold1-subtotal));
  if (Number(subtotal) < this.threshold2 && Number.isFinite(this.threshold2)) return `Je fietsbel is gratis! Nog ${this.formatMoney(this.threshold2-subtotal)} voor een gratis zwarte bivakmuts.`;
  return Number(subtotal) >= this.threshold2 ? 'Fietsbel + zwarte bivakmuts voor jou!' : this.labels.progressUnlocked;
}
isGiftRewardAvailable(tier) {
  return Boolean(tier && (tier.gifts || [tier.gift]).every(gift => gift?.variantId && gift.available));
}
getRewardCartVariantIds(tier) {
  if (!tier) return [];
  if (tier.level === 2) {
    const set = this.giftOptions.sets.find(variant => variant.size === this.giftSize);
    return set?.available && set.id ? [String(set.id)] : [];
  }
  return tier.gift?.available && tier.gift.variantId ? [String(tier.gift.variantId)] : [];
}
isRewardChoiceValid(tier) {
  if (!tier) return true;
  if (!this.giftSize) return false;
  const selected = this.selectedGift(1, {});
  return this.isGiftRewardAvailable(tier) && selected.available && selected.variantId === tier.gift.variantId;
}
summaryNodes(selector) {
  if (!this.summaryNodeCache.has(selector)) this.summaryNodeCache.set(selector, [...this.querySelectorAll(selector)]);
  return this.summaryNodeCache.get(selector);
}
syncRewardUI(tier) {
  const ready = this.isGiftRewardAvailable(tier);
  this.rewardChoice = ready ? 'gift' : '';
  this.summaryNodes('[data-qn-reward]').forEach(box => { box.hidden = !tier; });
  this.summaryNodes('[data-qn-mask-group]').forEach(el => { el.hidden = tier?.level !== 2; });
  if (!tier) return;
  this.summaryNodes('[data-qn-gift-heading]').forEach(el => { el.textContent = tier.level === 2 ? 'Twee cadeaus voor jou!' : 'Je gratis fietsbel staat klaar!'; });
  this.summaryNodes('[data-qn-gift-summary-title]').forEach(el => { el.textContent = tier.level === 2 ? 'Fietsbel + zwarte bivakmuts' : 'Fietsbel'; });
  this.summaryNodes('[data-qn-reward-tier]').forEach(el => { el.textContent = `Vanaf ${this.formatMoney(tier.threshold)}`; });
  this.summaryNodes('[data-qn-gift-size]').forEach(button => {
    const variant = this.giftOptions.singleSets.find(v => v.size === button.dataset.qnGiftSize);
    button.disabled = !variant?.available;
    button.setAttribute('aria-pressed',String(this.giftSize === variant?.size));
  });
  const message = tier.level === 2 && !this.gift2.available ? 'De zwarte bivakmuts is momenteel niet beschikbaar.' : ready ? (tier.level === 2 ? 'Je twee cadeaus staan klaar.' : 'Je cadeau is gekozen.') : this.giftOptions.singleSets.some(v=>v.available) ? 'Kies de kleur van je gratis fietsbel.' : 'Dit cadeau is momenteel uitverkocht.';
  this.summaryNodes('[data-qn-reward-message]').forEach(el=>{el.textContent=message;});
}
renderItemsHtml(items = this.bundleItems) {
  let html = '';
  items.forEach((item) => {
    const safeTitle = this.escapeHtml(item.title);
    const safeVariant = this.escapeHtml(item.variant);
    const safeImage = this.escapeHtml(item.image);
    const safeId = this.escapeHtml(item.variantId);
    html += `
      <div class="qn-bundle-summary__item" data-qn-summary-variant="${safeId}">
        <div class="qn-bundle-summary__item-media">
          ${safeImage ? `<img src="${safeImage}" alt="${safeTitle}" loading="lazy">` : ''}
        </div>
        <div>
          <p class="qn-bundle-summary__item-title">${safeTitle}</p>
          ${safeVariant && safeVariant !== 'Default Title' ? `<div class="qn-bundle-summary__item-variant">${safeVariant}</div>` : ''}
          <div class="qn-bundle-summary__item-price">${this.formatMoney(item.price)}</div>
          <div class="qn-bundle-summary__item-actions">
            <div class="qn-bundle-summary__qty" aria-label="Aantal">
              <button type="button" class="qn-bundle-summary__qty-btn" data-qn-qty-action="decrease" data-variant-id="${safeId}" aria-label="Aantal verlagen">−</button>
              <span class="qn-bundle-summary__qty-value">${item.quantity}</span>
              <button type="button" class="qn-bundle-summary__qty-btn" data-qn-qty-action="increase" data-variant-id="${safeId}" aria-label="Aantal verhogen">+</button>
            </div>
            <button type="button" class="qn-bundle-summary__remove" data-qn-remove data-variant-id="${safeId}">Verwijderen</button>
          </div>
        </div>
      </div>`;
  });
  return html;
}
syncSummaryItems(container) {
  const existing = new Map([...container.children].map(row => [row.dataset.qnSummaryVariant, row]));
  this.bundleItems.forEach(item => {
    const id = String(item.variantId);
    const row = existing.get(id);
    if (row) {
      const quantity = row.querySelector('.qn-bundle-summary__qty-value');
      if (quantity.textContent !== String(item.quantity)) quantity.textContent = String(item.quantity);
      existing.delete(id);
    } else {
      container.insertAdjacentHTML('beforeend', this.renderItemsHtml([item]));
    }
  });
  existing.forEach(row => row.remove());
}
syncMobileBar() {
  if (!this.mobileBar) return;
  const layout = this.querySelector('.qn-bundle__layout');
  const headerBottom = Math.max(0, document.querySelector('.cc-header')?.getBoundingClientRect().bottom || 0);
  const inProducts = (layout?.getBoundingClientRect().top ?? Infinity) < innerHeight * .65
    && this.getBoundingClientRect().bottom > headerBottom + 80;
  const hasItems = this.getTotalQuantity() > 0;
  this.mobileBar.hidden = !inProducts && !hasItems;
  this.mobileBar.classList.toggle('rb-browse-ready', !this.mobileBar.hidden);
  this.mobileBar.classList.toggle('is-compact', hasItems && !inProducts);
}
updateSummary() {
  const previewBar = document.getElementById('PBarNextFrame')?.getBoundingClientRect();
  const previewInset = previewBar && previewBar.height > 0 && previewBar.top < innerHeight ? Math.min(76, innerHeight - previewBar.top + 8) : 0;
  if (this.mobileBar) this.mobileBar.style.bottom = previewInset ? `${previewInset}px` : '';
  if (this.drawer) this.drawer.style.bottom = `${previewInset}px`;
  this.refreshRewardConfig();
  this.promotionExpired = this.isPromotionExpired();
  this.dataset.promotionExpired = String(this.promotionExpired);
  const quantity = this.getTotalQuantity();
  let subtotal = 0;
  this.bundleItems.forEach((item) => { subtotal += item.price * item.quantity; });
  const eligibleSubtotal = this.getEligibleSelectionAmount();
  const tier = this.promotionExpired ? null : this.getRewardTier(eligibleSubtotal);
  const unlockedLevel = tier && tier.level > (this.previousRewardLevel || 0) ? tier.level : 0;
  this.previousRewardLevel = tier?.level || 0;
  this.dataset.qnRewardLevel = String(tier?.level || 0);
  this.syncRewardUI(tier);
  const hasGift = Boolean(tier && this.rewardChoice === 'gift' && this.isGiftRewardAvailable(tier));
  const total = subtotal;
  const hasItems = quantity > 0;
  this.summaryNodes('[data-qn-empty]').forEach((el) => { el.hidden = hasItems; });
  this.summaryNodes('[data-qn-items]').forEach((el) => {
    el.hidden = !hasItems;
    this.syncSummaryItems(el);
  });
  this.summaryNodes('[data-qn-totals]').forEach((el) => { el.hidden = !hasItems; });
  this.summaryNodes('[data-qn-progress]').forEach((el) => { el.hidden = false; });
  this.summaryNodes('[data-qn-tier-threshold]').forEach((el) => {
    el.classList.toggle('is-unlocked', !this.promotionExpired && quantity >= this.minItems && eligibleSubtotal >= Number(el.getAttribute('data-qn-tier-threshold')));
  });
  this.summaryNodes('[data-qn-count]').forEach((el) => { el.textContent = String(quantity); });
  this.summaryNodes('[data-qn-subtotal]').forEach((el) => { el.textContent = this.formatMoney(subtotal); });
  this.summaryNodes('[data-qn-eligible-amount]').forEach(el => { el.hidden = !hasItems || eligibleSubtotal === subtotal; el.textContent = `Voor de cadeauactie: ${this.formatMoney(eligibleSubtotal)}`; });
  this.summaryNodes('[data-qn-total]').forEach((el) => { el.textContent = this.formatMoney(total); });
  this.summaryNodes('[data-qn-gift-row]').forEach((row) => { row.hidden = !(hasItems && hasGift); });
  this.summaryNodes('[data-qn-gift-label]').forEach((el) => {
    if (hasGift && tier && tier.gift) {
      const giftValue = (tier.gifts || [tier.gift]).reduce((sum,gift)=>sum + Number(gift.value || 0),0);
      const priceHtml = giftValue > 0 ? ` <span class="qn-bundle-summary__gift-price">${this.escapeHtml(this.formatMoney(giftValue))}</span>` : '';
      el.innerHTML = `Gratis${priceHtml}`;
    } else {
      el.textContent = '';
    }
  });
  this.summaryNodes('[data-qn-progress-text]').forEach((el) => { el.textContent = this.getProgressText(eligibleSubtotal); });
  const progressValue = Math.max(0, Math.min(100, this.getProgress(eligibleSubtotal)));
  this.summaryNodes('[data-qn-progress-fill]').forEach((el) => {
    el.style.transform = `scaleX(${progressValue / 100})`;
  });
  this.summaryNodes('[data-qn-progress-bar]').forEach((el) => {
    el.setAttribute('aria-valuenow', String(Math.round(progressValue)));
    el.setAttribute('aria-valuetext', this.getProgressText(eligibleSubtotal));
  });
  const meetsMinimum = quantity >= this.minItems;
  const rewardReady = !tier || this.isRewardChoiceValid(tier);
  this.checkoutButtons.forEach((button) => {
    button.disabled = Boolean(this.cartSubmitting) || (!this.cartNeedsReview && (this.promotionExpired || !meetsMinimum));
    button.textContent = this.cartNeedsReview ? 'Winkelwagen controleren' : this.promotionExpired ? 'Actie afgelopen' : tier && !rewardReady ? 'Kies hierboven je cadeau ↑' : button.dataset?.qnCartDestination === 'cart' ? 'In de winkelwagen' : this.baseCheckoutLabel;
  });
  this.summaryNodes('.qn-bundle-runner').forEach(runner=>{
    runner.style.left='clamp(0px, calc('+progressValue+'% - 30px), calc(100% - 60px))';
  });
  if (this.previousProgress !== undefined && progressValue !== this.previousProgress) this.animateRunner(unlockedLevel, progressValue);
  this.previousProgress = progressValue;
  this.previousQuantity=quantity;
  this.syncMobileBar();
  this.summaryNodes('[data-qn-mobile-count]').forEach((el) => {
    const label = quantity === 1 ? this.labels.singular : this.labels.plural;
    el.textContent = `${quantity} ${label}`;
  });
  this.summaryNodes('[data-qn-mobile-total]').forEach((el) => { el.textContent = this.formatMoney(total); });
  if (!hasItems && this.drawer?.classList.contains('is-open')) this.closeDrawer();
}
getActiveRewardCode(tier) {
  if (!tier || !this.rewardChoice) return '';
  if (this.rewardChoice === 'gift') return tier.giftCode || '';
  return '';
}
isManagedRewardItem(item) {
  const variantId = String(item.variant_id || item.id || '');
  if (!variantId || item.properties?.['_ROCKBROS Herfstcadeau'] !== 'Gratis cadeau') return false;
  // Only marked campaign gifts may be changed; never touch an unmarked paid copy.
  const currentGift = [...(this.giftOptions?.singleSets || []), ...(this.giftOptions?.sets || []), ...(this.giftOptions?.masks || [])]
    .some(variant => String(variant.id) === variantId);
  const legacyGift = false;
  return currentGift || legacyGift || variantId === this.gift1?.variantId || variantId === this.gift2?.variantId;
}
async readRewardCart() {
  const response = await fetch(`${this.rootUrl}cart.js`, {
    headers: { 'Accept': 'application/json' }, cache: 'no-store'
  });
  if (!response.ok) throw new Error(this.labels.cartError);
  const cart = await response.json();
  if (!Array.isArray(cart?.items)) throw new Error(this.labels.cartError);
  return cart;
}
async reconcileRewardCart(cart, desiredVariantIds) {
  const desired = [...new Set((Array.isArray(desiredVariantIds) ? desiredVariantIds : [desiredVariantIds]).filter(Boolean).map(String))];
  let remainingChanges = cart.items.filter(item => this.isManagedRewardItem(item)).length + 1;
  while (true) {
    const managed = cart.items.filter(item => this.isManagedRewardItem(item));
    const keep = desired.map(id => managed.find(item => String(item.variant_id || item.id) === id));
    if (keep.some(item => !item)) throw new Error(this.labels.cartError);
    const change = managed.find(item => !keep.includes(item) || item.quantity !== 1);
    if (!change) return;
    if (!remainingChanges-- || typeof change.key !== 'string' || !change.key) throw new Error(this.labels.cartError);
    const response = await fetch(`${this.rootUrl}cart/change.js`, {
      method:'POST', headers:{'Content-Type':'application/json','Accept':'application/json'},
      body:JSON.stringify({id:change.key,quantity:keep.includes(change) ? 1 : 0})
    });
    if (!response.ok) throw new Error(this.labels.cartError);
    cart = await this.readRewardCart();
  }
}
async readCartPromotionAmount() {
  const response = await fetch(`${this.rootUrl}cart`, {headers:{Accept:'text/html'},cache:'no-store'});
  if (!response.ok) throw new Error(this.labels.cartError);
  const offer = new DOMParser().parseFromString(await response.text(), 'text/html').querySelector('[data-rb-gift-offer]');
  const raw = offer?.getAttribute('data-promo-amount');
  const amount = raw == null || raw === '' ? NaN : Number(raw);
  if (!Number.isFinite(amount) || amount < 0) throw new Error('Het actiebedrag kon niet worden gecontroleerd.');
  return amount;
}
reviewCart(message) {
  this.cartNeedsReview = true;
  this.showToast(message, 'error');
  try { sessionStorage.setItem('rbAutumnCartNotice', message); } catch (error) { /* Cart remains accessible without storage. */ }
  window.location.href = `${this.rootUrl}cart?rb_gift_review=1`;
}
async addBundleToCart(triggerButton) {
  if (this.cartSubmitting) return;
  if (this.cartNeedsReview) { window.location.href = `${this.rootUrl}cart`; return; }
  if (this.isPromotionExpired()) { this.updateSummary(); this.showToast('Deze actie is afgelopen. Er zijn geen actieproducten toegevoegd.', 'error'); return; }
  if (this.getTotalQuantity() < this.minItems || !this.bundleItems.size) return;
  if (this.dataset.preview === 'true') { this.showToast('Voorbeeld: je selectie is klaar. Er is niets toegevoegd aan je winkelwagen.'); return; }
  if (this.dataset.giftsVerified !== 'true') { this.showToast('De cadeauactie is nog niet actief. Je kunt deze producten via de productpagina normaal kopen.','error'); return; }
  const submitted = [...this.bundleItems.values()].map(selection => ({id:Number(selection.variantId),quantity:Number(selection.quantity)||1,selection}));
  const buttons = this.checkoutButtons;
  this.cartSubmitting = true;
  buttons.forEach(button => { button.disabled = true; button.setAttribute('aria-busy','true'); });
  try {
    const response = await fetch(`${this.rootUrl}cart/add.js`, {method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({items:submitted.map(({id,quantity})=>({id,quantity}))})});
    if (!response.ok) {
      let message = this.labels.cartError;
      try { const data = await response.json(); message = data.description || data.message || message; } catch (error) {}
      throw new Error(message);
    }
    // Paid quantities are consumed immediately, even if a later gift check fails.
    submitted.forEach(({id,quantity,selection}) => {
      const selected = this.bundleItems.get(String(id));
      if (selected !== selection) return;
      if (selected.quantity <= quantity) this.bundleItems.delete(String(id)); else selected.quantity -= quantity;
      this.syncAllAddButtons(String(id));
    });
    let cart = await this.readRewardCart();
    const eligibleAmount = await this.readCartPromotionAmount();
    const existingGift = cart.items.find(item => this.isManagedRewardItem(item));
    const existingChoice = existingGift && [...this.giftOptions.singleSets,...this.giftOptions.sets].find(v => String(v.id) === String(existingGift.variant_id || existingGift.id));
    if (!this.giftSize && existingChoice) this.giftSize = existingChoice.size;
    this.refreshRewardConfig();
    const tier = this.getRewardTier(eligibleAmount);
    if (tier && !this.giftSize) { this.reviewCart('Je producten zijn toegevoegd. Kies in je winkelwagen de kleur van je gratis fietsbel.'); return; }
    const desiredIds = tier ? this.getRewardCartVariantIds(tier) : [];
    if (tier && (!this.isRewardChoiceValid(tier) || !desiredIds.length || !tier.giftCode)) throw new Error('Je cadeau is niet beschikbaar. Controleer je winkelwagen.');
    const missing = desiredIds.filter(id => !cart.items.some(item => this.isManagedRewardItem(item) && String(item.variant_id || item.id) === id));
    if (missing.length) {
      const added = await fetch(`${this.rootUrl}cart/add.js`, {method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({items:missing.map(id=>({id:Number(id),quantity:1,properties:{'_ROCKBROS Herfstcadeau':'Gratis cadeau'}}))})});
      if (!added.ok) throw new Error('Je cadeau kon niet worden toegevoegd.');
      cart = await this.readRewardCart();
    }
    await this.reconcileRewardCart(cart, desiredIds);
    cart = await this.readRewardCart();
    const codes = (cart.discount_codes || []).map(discount => discount.code).filter(code => code && ![this.giftCode1,this.giftCode2].some(own => own && own.toLowerCase() === code.toLowerCase()));
    if (tier) codes.push(tier.giftCode);
    const applied = await fetch(`${this.rootUrl}cart/update.js`, {method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({discount:codes.join(',')})});
    if (!applied.ok) throw new Error('De cadeaukorting kon niet worden gecontroleerd.');
    const verified = await this.readRewardCart();
    const gifts = verified.items.filter(item => this.isManagedRewardItem(item));
    if (gifts.length !== desiredIds.length || gifts.some(item => !desiredIds.includes(String(item.variant_id || item.id)) || item.quantity !== 1 || Number(item.final_line_price) !== 0)) {
      try {
        await this.reconcileRewardCart(verified, []);
        const remainingCodes = (verified.discount_codes || []).map(discount => discount.code).filter(code => code && ![this.giftCode1,this.giftCode2].some(own => own && own.toLowerCase() === code.toLowerCase()));
        const cleared = await fetch(`${this.rootUrl}cart/update.js`, {method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({discount:remainingCodes.join(',')})});
        if (!cleared.ok) throw new Error('discount cleanup failed');
        const cleaned = await this.readRewardCart();
        if (cleaned.items.some(item => this.isManagedRewardItem(item))) throw new Error('gift cleanup incomplete');
      } catch (cleanupError) {
        throw new Error('De cadeaukorting is niet bevestigd en de opruiming kon niet worden voltooid. Controleer de prijs en verwijder eventuele betaalde cadeaus voordat je afrekent.');
      }
      throw new Error('Je cadeau is nog niet gratis verwerkt. Het actiecadeau is verwijderd; je betaalde producten blijven in je winkelwagen.');
    }
    window.location.href = `${this.rootUrl}${triggerButton?.dataset?.qnCartDestination === 'cart' ? 'cart' : 'checkout'}`;
  } catch (error) {
    this.reviewCart(`${error?.message || this.labels.cartError} Controleer je winkelwagen voordat je producten opnieuw toevoegt.`);
  } finally {
    this.cartSubmitting = false;
    this.updateSummary();
    buttons.forEach(button => button.removeAttribute('aria-busy'));
  }
}
isMobileView() {
  return window.matchMedia('(max-width: 989px)').matches;
}
buildProductJsonUrl(productUrl) {
  try {
    const url = new URL(productUrl, window.location.origin);
    url.search = '';
    url.hash = '';
    if (!url.pathname.endsWith('.js')) url.pathname = `${url.pathname.replace(/\/$/, '')}.js`;
    return url.toString();
  } catch (error) {
    const clean = String(productUrl || '').split('#')[0].split('?')[0].replace(/\/$/, '');
    return clean ? `${clean}.js` : '';
  }
}
sanitizeProductDescription(html) {
  const parser = new DOMParser();
  const doc = parser.parseFromString(String(html || ''), 'text/html');
  doc.querySelectorAll('script, style, iframe, object, embed, form, input, button, textarea').forEach((el) => el.remove());
  doc.body.querySelectorAll('*').forEach((el) => {
    [...el.attributes].forEach((attr) => {
      const name = attr.name.toLowerCase();
      const value = String(attr.value || '').trim().toLowerCase();
      if (name.startsWith('on')) el.removeAttribute(attr.name);
      if ((name === 'href' || name === 'src') && value.startsWith('javascript:')) el.removeAttribute(attr.name);
    });
  });
  return doc.body.innerHTML.trim();
}
loadPreviewImage(url) {
  this.previewImageCache ||= new Map();
  if (this.previewImageCache.has(url)) return this.previewImageCache.get(url);
  const image = new Image();
  image.decoding = 'async';
  image.src = url;
  const ready = image.decode().then(() => url).catch(error => {
    this.previewImageCache.delete(url);
    throw error;
  });
  this.previewImageCache.set(url, ready);
  // Bound the cache while retaining browser HTTP caching for revisits.
  if (this.previewImageCache.size > 20) this.previewImageCache.delete(this.previewImageCache.keys().next().value);
  return ready;
}
async showPreviewImage(mainImage, url) {
  const request = (this.previewImageRequest || 0) + 1;
  this.previewImageRequest = request;
  const media = mainImage.closest('.qn-bundle-card__media');
  media?.setAttribute('aria-busy', 'true');
  try {
    await this.loadPreviewImage(url);
    if (request !== this.previewImageRequest || !mainImage.isConnected) return;
    mainImage.removeAttribute('srcset');
    mainImage.src = url;
  } catch (error) {
    if (request === this.previewImageRequest) {
      this.syncPreviewGallery(mainImage.closest('[data-qn-product-card]'));
      this.showToast('De afbeelding kon niet worden geladen. Probeer het opnieuw.', 'error');
    }
  } finally {
    if (request === this.previewImageRequest) media?.removeAttribute('aria-busy');
  }
}
preloadPreviewNeighbors(button) {
  const siblings = [...button.parentElement.querySelectorAll('[data-qn-preview-image]')];
  const index = siblings.indexOf(button);
  for (const next of [siblings[index - 1], siblings[index + 1]]) {
    if (next) this.loadPreviewImage(next.dataset.qnPreviewImage).catch(() => {});
  }
}
previewImageUrl(value, width = this.isMobileView() ? 720 : 1000) {
  try {
    if (!value) return '';
    const url = new URL(typeof value === 'string' ? value : value.src, window.location.origin);
    if (!['http:', 'https:'].includes(url.protocol)) return '';
    url.searchParams.set('width', String(width));
    return url.href;
  } catch (error) { return ''; }
}
getPreviewProduct(jsonUrl) {
  if (this.productPreviewCache.has(jsonUrl)) return this.productPreviewCache.get(jsonUrl);
  const controller = new AbortController();
  const timeout = window.setTimeout(() => controller.abort(), 10000);
  const request = fetch(jsonUrl, { headers: { 'Accept': 'application/json' }, signal: controller.signal })
    .then(response => { if (!response.ok) throw new Error('Productdetails konnten nicht geladen werden.'); return response.json(); })
    .catch(error => { this.productPreviewCache.delete(jsonUrl); throw error; })
    .finally(() => window.clearTimeout(timeout));
  this.productPreviewCache.set(jsonUrl, request);
  return request;
}
renderSeparatedPreviewOptions(product, variants, card, selectedId) {
  const addButton = card.querySelector('[data-qn-add]');
  const options = (product.options || []).map((option, index) => {
    const name = typeof option === 'string' ? option : option.name;
    const color = /^(colou?r|kleur|farbe|颜色|patroon|pattern|dessin)$/i.test(name);
    const size = /^(size|maat|größe|groesse|尺寸|尺码)(\b|\s|$)/i.test(name);
    return {index, name: color ? 'Kleur' : size ? 'Maat' : name, color, size};
  }).sort((a,b) => Number(b.color)-Number(a.color) || Number(b.size)-Number(a.size) || a.index-b.index);
  const values = variant => variant.options || [variant.option1,variant.option2,variant.option3].filter(v=>v!=null);
  let selected = variants.find(v=>String(v.id)===String(selectedId)) || variants.find(v=>v.available) || variants[0];
  const group = document.createElement('div');
  group.className = 'qn-bundle-card__variants qn-preview-separated-options';
  addButton.before(group);
  const apply = variant => {
    selected = variant;
    this.applyVariantToCard({dataset:{variantId:String(variant.id),variantTitle:variant.title,variantPrice:String(variant.price),variantCompare:String(variant.compare_at_price||0),variantAvailable:String(variant.available),variantImage:this.previewImageUrl(variant.featured_image||product.featured_image)}},card);
  };
  if (variants.length===1 && /^(default title|standard)$/i.test(variants[0].title)) {apply(selected);return;}
  const controls=[];
  const sync=()=>controls.forEach(({input,label,option,value,prior})=>{
    input.checked=values(selected)[option.index]===value;
    input.disabled=!variants.some(v=>v.available && values(v)[option.index]===value && prior.every(o=>values(v)[o.index]===values(selected)[o.index]));
    label.dataset.available=String(!input.disabled);
  });
  options.forEach((option,order)=>{
    const field=document.createElement('fieldset');
    const legend=document.createElement('legend');legend.textContent=option.name;field.append(legend);
    const row=document.createElement('div');row.className='qn-preview-option-row';field.append(row);
    [...new Set(variants.map(v=>values(v)[option.index]))].forEach(value=>{
      const label=document.createElement('label');label.className='qn-preview-option';
      const input=document.createElement('input');input.type='radio';input.name='preview-option-'+product.id+'-'+option.index;input.value=value;
      const colorNames={black:'Zwart',white:'Wit',brown:'Bruin',grey:'Grijs',gray:'Grijs',red:'Rood',blue:'Blauw',green:'Groen',yellow:'Geel',pink:'Roze',purple:'Paars',orange:'Oranje'};
      const text=option.color ? (colorNames[String(value).toLowerCase()] || value) : option.size && /^(?:[2-6]?x?[sml]|xx[sl]|xxx[sl])$/i.test(value) ? value.toUpperCase() : value;
      input.setAttribute('aria-label',text);
      const content=document.createElement('span');
      if(option.color){
        const sample=variants.find(v=>values(v)[option.index]===value && v.featured_image);
        if(sample){const image=document.createElement('img');image.src=this.previewImageUrl(sample.featured_image,100);image.alt='';image.width=40;image.height=40;content.append(image);}
      }
      const caption=document.createElement('span');caption.textContent=text;content.append(caption);
      label.append(input,content);row.append(label);
      const prior=options.slice(0,order);
      controls.push({input,label,option,value,prior});
      input.addEventListener('change',()=>{
        const matches=variants.filter(v=>v.available && values(v)[option.index]===value && prior.every(o=>values(v)[o.index]===values(selected)[o.index]));
        const next=matches.find(v=>options.every(o=>o.index===option.index || values(v)[o.index]===values(selected)[o.index])) || matches[0];
        if(next)apply(next);
        sync();
      });
    });
    group.append(field);
  });
  apply(selected);sync();
}
renderPreviewOptions(product, card) {
  const media = card.querySelector('.qn-bundle-card__media');
  const mainImage = card.querySelector('[data-qn-main-image]');
  const oldGallery = card.querySelector('.qn-product-preview__gallery');
  oldGallery?.remove();
  const gallery = document.createElement('div');
  gallery.className = 'qn-product-preview__gallery';
  gallery.setAttribute('aria-label', 'Productafbeeldingen');
  (product.images || []).forEach((value, index) => {
    const fullImage = this.previewImageUrl(value);
    if (!fullImage) return;
    const button = document.createElement('button');
    button.type = 'button';
    button.dataset.qnPreviewImage = fullImage;
    button.setAttribute('aria-label', 'Productafbeelding ' + (index + 1) + ' bekijken');
    button.setAttribute('aria-pressed', String(index === 0));
    const image = document.createElement('img');
    image.src = this.previewImageUrl(value, 100);
    image.alt = '';
    image.loading = 'lazy';
    image.width = 64;
    image.height = 64;
    button.append(image);
    gallery.append(button);
  });
  if (gallery.children.length) media?.after(gallery);
  card.querySelector('.qn-preview-gallery-controls')?.remove();
  const controls=document.createElement('div'); controls.className='qn-preview-gallery-controls';
  controls.innerHTML='<button type="button" data-qn-gallery-step="-1" aria-label="Vorige productafbeelding">←</button><span data-qn-image-count>1 / '+gallery.children.length+'</span><button type="button" data-qn-gallery-step="1" aria-label="Volgende productafbeelding">→</button>';
  if (gallery.children.length > 1) media?.append(controls);
  const addButton = card.querySelector('[data-qn-add]');
  const selectedId = addButton?.dataset.variantId;
  const allowedIds = card.dataset.qnAllowedVariantIds?.split(',');
  const previewVariants = allowedIds
    ? allowedIds.map(id => product.variants?.find(variant => String(variant.id) === id)).filter(Boolean)
    : product.variants || [];
  card.querySelector('.qn-bundle-card__variants')?.remove();
  card.querySelector('.qn-product-preview__variant-select')?.remove();
  if (previewVariants.length > 0 && addButton) {
    this.renderSeparatedPreviewOptions(product, previewVariants, card, selectedId);
  } else if (mainImage && product.featured_image && product.variants?.length <= 1) {
    mainImage.src = this.previewImageUrl(product.featured_image);
    mainImage.removeAttribute('srcset');
  }
  if (mainImage && previewVariants.length === 1 && product.images?.[0]) {
    mainImage.src = this.previewImageUrl(product.images[0]);
    mainImage.removeAttribute('srcset');
  }
  this.syncPreviewGallery(card);
  const active = gallery.querySelector('[aria-pressed="true"]') || gallery.firstElementChild;
  if (active) this.preloadPreviewNeighbors(active);
}
async loadProductPreviewDetails(productUrl, detailsEl) {
  const body = detailsEl?.querySelector('[data-qn-product-preview-details-body]');
  if (!body) return;
  body.textContent = 'Productdetails laden …';
  try {
    const card = detailsEl.closest('[data-qn-product-preview-clone]');
    const giftLevel = card?.dataset.qnGiftPreviewLevel;
    let product = await this.getPreviewProduct(this.buildProductJsonUrl(productUrl));
    if (giftLevel === '2') {
      // The gift is the single black item; never show the original two-pack gallery.
      try {
        const display = await this.getPreviewProduct(this.buildProductJsonUrl((window.Shopify?.routes?.root || '/') + 'products/cadeau-zwarte-thermische-bivakmuts-1-stuk'));
        product = { ...display, images: [display.featured_image || this.gift2.image].filter(Boolean), variants: [] };
      } catch {
        product = { ...product, featured_image: this.gift2.image, images: [this.gift2.image].filter(Boolean), variants: [], description: '<p>Een zwarte thermische bivakmuts voor koude fietsritten, met bedekking voor hoofd en nek.</p><p>Kleur: Zwart</p><p>Aantal: 1 stuk</p><p>Model: LF7345BK</p>' };
      }
    } else if (giftLevel) {
      product = { ...product, variants: [] };
    }
    if (!detailsEl.isConnected) return;
    this.renderPreviewOptions(product, detailsEl.closest('[data-qn-product-preview-clone]'));
    if (giftLevel) {
      let options = card.querySelector('[data-qn-gift-preview-options]');
      if (!options) {
        options = document.createElement('div');
        options.dataset.qnGiftPreviewOptions = '';
        options.className = 'qn-gift-choice-group';
        const source = this.querySelector(giftLevel === '2' ? '[data-qn-mask-group]' : '.qn-gift-selection .qn-gift-choice-group');
        const choices = source?.querySelector('.qn-gift-choice-options')?.cloneNode(true);
        const heading = document.createElement('strong');
        heading.textContent = giftLevel === '2' ? 'Zwart · 1 stuk' : 'Kies je kleur';
        options.append(heading);
        if (choices) options.append(choices);
        card.querySelector('[data-qn-gift-preview-value]').after(options);
      }
      options.querySelector('strong').textContent = giftLevel === '2' ? 'Zwart · 1 stuk' : 'Kies je kleur';
      options.querySelectorAll('button').forEach(button => {
        if(button.dataset.qnGiftColor) button.setAttribute('aria-label',button.dataset.qnGiftColor);
        const selected = button.hasAttribute('data-qn-gift-color') ? this.giftColor === button.dataset.qnGiftColor : this.giftSize === button.dataset.qnGiftSize;
        button.setAttribute('aria-pressed', String(selected));
      });
      if (giftLevel === '1') {
        const selectedBell = this.giftOptions.singleSets.find(variant => variant.size === this.giftSize) || this.giftOptions.singleSets[0];
        const image = card.querySelector('[data-qn-main-image]');
        if (selectedBell?.image && image) {
          this.showPreviewImage(image, this.previewImageUrl(selectedBell.image));
          this.syncPreviewGallery(card);
        }
      }
      if (giftLevel === '2') {
        card.querySelector('.qn-bundle-card__title').textContent = 'Zwarte bivakmuts · 1 stuk';
        card.querySelector('[data-qn-main-image]').src = this.previewImageUrl(product.images[0] || this.gift2.image);
        const value = card.querySelector('[data-qn-gift-preview-value]');
        if (value?.tagName === 'P') value.textContent = 'Cadeau · Waarde '+this.formatMoney(this.gift2.value);
      }
    }
    const description = this.sanitizeProductDescription(product.description || '');
    const bellDetails = giftLevel === '1' && String(product.id) === '7761546641474' && this.querySelector('template[data-rb-bell-details]');
    if (bellDetails) {
      body.replaceChildren(bellDetails.content.cloneNode(true));
      card.querySelector('.qn-bundle-card__title').textContent = 'ROCKBROS fietsbel';
    } else {
      body.innerHTML = description || '<p>Er is nog geen verdere productbeschrijving beschikbaar.</p>';
      window.RBNLProductDetails?.format(body);
    }
    if (giftLevel === '2' && !body.querySelector('table')) {
      const specs = window.RBNLProductDetails?.table([['Kleur', 'Zwart'], ['Aantal', '1 stuk'], ['Model', 'LF7345BK']]);
      if (specs) body.append(specs);
    }
    if (giftLevel !== '2' && !bellDetails) await window.RBNLProductDetails?.loadSpecs(body, productUrl);
    if (!body.isConnected) return;
    window.RBNLProductDetails?.tabs(body);
    body.querySelectorAll('img').forEach(image => { if (giftLevel) image.remove(); else { image.loading = 'lazy'; image.decoding = 'async'; } });
  } catch (error) {
    body.textContent = 'De productdetails konden niet worden geladen. Probeer het opnieuw of open de productpagina.';
    const retry = document.createElement('button');
    retry.type = 'button';
    retry.setAttribute('data-qn-retry-details', '');
    retry.dataset.productUrl = productUrl;
    retry.textContent = 'Opnieuw proberen';
    body.append(retry);
  }
}
setupPreviewDock(button) {
  this.previewDockCleanup?.();
  if (!button) return;
  const drawer=this.productPreviewDrawer;
  const dock=document.createElement('div');dock.className='rb-preview-dock';dock.hidden=true;
  const add=document.createElement('button');add.type='button';add.className='rb-preview-dock__add';
  const top=document.createElement('button');top.type='button';top.className='rb-preview-dock__top';top.textContent='↑';top.setAttribute('aria-label','Terug naar boven');top.title='Terug naar boven';
  dock.append(add,top);this.append(dock);this.previewDock=dock;
  add.addEventListener('click',()=>button.click());
  top.addEventListener('click',()=>{drawer.scrollTo({top:0,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});drawer.querySelector('[data-qn-close-product-preview]')?.focus({preventScroll:true});});
  const sync=()=>{
    const rect=drawer.getBoundingClientRect();
    const header=drawer.querySelector('.qn-product-preview__header').getBoundingClientRect();
    dock.hidden=!drawer.classList.contains('is-open') || (button.hidden ? button.parentElement.querySelector('[data-qn-card-quantity]') : button).getBoundingClientRect().bottom>header.bottom;
    dock.style.right=Math.max(16,innerWidth-rect.right+16)+'px';
    const previewBar=document.getElementById('PBarNextFrame')?.getBoundingClientRect();
    const previewInset=previewBar && previewBar.height>0 && previewBar.top<innerHeight ? Math.min(76,innerHeight-previewBar.top+12) : 0;
    dock.style.bottom=Math.max(20,innerHeight-rect.bottom+20,previewInset)+'px';
    add.textContent=button.textContent.trim();add.disabled=button.disabled;
  };
  drawer.addEventListener('scroll',sync,{passive:true});window.addEventListener('resize',sync);
  const observer=new MutationObserver(sync);observer.observe(button,{attributes:true,childList:true,subtree:true,characterData:true});
  this.previewDockCleanup=()=>{observer.disconnect();drawer.removeEventListener('scroll',sync);window.removeEventListener('resize',sync);dock.remove();this.previewDock=null;this.previewDockCleanup=null;};
  sync();
}
openProductPreview(sourceCard, trigger) {
  if (!this.productPreviewDrawer || !this.productPreviewOverlay || !this.productPreviewContent || !sourceCard) return;
  this.returnToBundle = this.drawer?.classList.contains('is-open');
  this.returnBundleTrigger = this.drawerTrigger;
  if (this.returnToBundle) this.closeDrawer(false);
  const clone = sourceCard.cloneNode(true);
  clone.classList.remove('qn-mobile-product-deferred');
  clone.removeAttribute('role');
  clone.setAttribute('data-qn-product-preview-clone', 'true');
  const zoomButton=document.createElement('button');
  zoomButton.type='button';zoomButton.dataset.qnPreviewZoom='';zoomButton.textContent='⤢';zoomButton.setAttribute('aria-label','Afbeelding vergroten');
  clone.querySelector('.qn-bundle-card__media')?.append(zoomButton);

  clone.querySelectorAll('.qn-bundle-card__media-link, .qn-bundle-card__title a').forEach(link => {
    const text = document.createElement('span');
    text.className = link.className;
    text.append(...link.childNodes);
    link.replaceWith(text);
  });
  const unique = `quick-${Date.now()}-${Math.random().toString(36).slice(2, 7)}`;
  clone.querySelectorAll('[data-qn-variant-input]').forEach((input) => {
    input.name = `${input.name || 'qn-variant'}-${unique}`;
  });
  const details = document.createElement('section');
  details.className = 'qn-product-preview__details';
  details.setAttribute('data-qn-product-preview-details', '');
  details.innerHTML = `
    <h4 class="qn-product-preview__details-title">Productdetails</h4>
    <div class="qn-product-preview__details-body" data-qn-product-preview-details-body>
      <div class="qn-product-preview__details-loading">Productdetails laden …</div>
    </div>
  `;
  const cloneAddButton = clone.querySelector('[data-qn-add]');
  if (cloneAddButton) this.syncAddButtonState(cloneAddButton);
  clone.append(details);
  window.RBNLProductDetails?.shipping(clone, this);
  this.productPreviewContent.replaceChildren(clone);
  this.productPreviewTrigger = trigger || null;
  const productUrl = sourceCard.querySelector('.qn-bundle-card__media-link')?.getAttribute('href') || '';
  const pageLink = document.createElement('a');
  pageLink.className = 'qn-product-preview__details-link';
  pageLink.href = productUrl;
  pageLink.target = '_blank';
  pageLink.rel = 'noopener';
  pageLink.textContent = 'Productpagina openen ↗';
  details.before(pageLink);
  this.loadProductPreviewDetails(productUrl, details);
  this.productPreviewDrawer.scrollTop = 0;
  this.productPreviewDrawer.classList.add('is-open');
  this.productPreviewOverlay.classList.add('is-open');
  this.productPreviewDrawer.setAttribute('aria-hidden', 'false');
  this.productPreviewDrawer.inert = false;
  this.setupPreviewDock(cloneAddButton);
  document.body.style.overflow = 'hidden';
  requestAnimationFrame(() => {
    this.productPreviewDrawer.querySelector('[data-qn-close-product-preview]')?.focus({ preventScroll: true });
  });
}
closeProductPreview(restoreFocus = true) {
  this.previewDockCleanup?.();
  if (!this.productPreviewDrawer || !this.productPreviewOverlay) return;
  this.productPreviewDrawer.classList.remove('is-open');
  this.productPreviewOverlay.classList.remove('is-open');
  this.productPreviewDrawer.setAttribute('aria-hidden', 'true');
  this.productPreviewDrawer.inert = true;
  if (!this.drawer?.classList.contains('is-open')) {
    document.body.style.overflow = '';
  }
  const trigger = this.productPreviewTrigger;
  this.productPreviewTrigger = null;
  if (restoreFocus && this.returnToBundle) {
    const opener=this.returnBundleTrigger;
    this.returnToBundle=false;
    this.openDrawer(opener);
  }
  if (restoreFocus) trigger?.focus?.({ preventScroll: true });
}
openDrawer(trigger) {
  if (!this.drawer || !this.overlay) return;
  if (this.productPreviewDrawer?.classList.contains('is-open')) this.closeProductPreview(false);
  this.drawerTrigger = trigger || null;
  this.drawer.classList.add('is-open');
  this.dataset.bundleDrawerOpen = 'true';
  this.overlay.classList.add('is-open');
  this.drawer.setAttribute('aria-hidden', 'false');
  this.drawer.inert = false;
  document.body.style.overflow = 'hidden';
  this.drawer.querySelector('[data-qn-close-drawer]')?.focus({ preventScroll: true });
}
closeDrawer(restoreFocus = true) {
  if (!this.drawer || !this.overlay) return;
  this.drawer.classList.remove('is-open');
  this.dataset.bundleDrawerOpen = 'false';
  this.overlay.classList.remove('is-open');
  this.drawer.setAttribute('aria-hidden', 'true');
  this.drawer.inert = true;
  if (!this.productPreviewDrawer?.classList.contains('is-open')) {
    document.body.style.overflow = '';
  }
  const trigger = this.drawerTrigger;
  this.drawerTrigger = null;
  if (restoreFocus) trigger?.focus?.({ preventScroll: true });
}
showToast(message, type = 'default') {
  if (!this.toast) return;
  if (this.toastTimer) window.clearTimeout(this.toastTimer);
  this.toast.dataset.type = type;
  this.toast.textContent = message;
  this.toast.classList.add('is-visible');
  this.toastTimer = window.setTimeout(() => {
    this.toast.classList.remove('is-visible');
  }, 2400);
}
  }
  customElements.define('rbnl-autumn-builder-v1', QunatureBundleBuilder);
})();






